import type { VcsConnection } from 'components/organizations/vcs/vcs-connection-modal/vcs-connection-modal-picker';
import type { AuthenticationType } from './use-connection-modal-access-card-form.hook';
import type { VcsApi } from '@env0/vcs-service/api';
import { showHiddenFeatures } from 'constants/config';

export function getAvailableAuthenticationTypes(vcsConnection: VcsConnection): AuthenticationType[] {
  switch (vcsConnection.type) {
    case 'VcsTester':
      return ['VcsAgent', 'OAuth', 'AccessToken'];
    case 'GitHub':
      return ['OAuth'];
    case 'AzureDevOps':
    case 'BitBucket':
      return showHiddenFeatures() ? ['OAuth'] : [];
    case 'GitLab':
      return showHiddenFeatures() ? ['OAuth', 'AccessToken'] : [];
    case 'BitBucketServer':
    case 'GitHubEnterprise':
    case 'GitLabEnterprise':
      return ['VcsAgent'];
    default:
      return [];
  }
}

export function getSupportedConnectionTypes(vcsType: VcsApi.VcsType): VcsApi.ConnectionType[] | undefined {
  switch (vcsType) {
    case 'VcsTester':
      return ['DeploymentPipeline', 'CodeWrite'];
    case 'GitHub':
      return ['DeploymentPipeline', 'CodeWrite'];
    case 'BitBucketServer':
    case 'GitLabEnterprise':
      return ['DeploymentPipeline'];
    case 'GitHubEnterprise':
      return ['DeploymentPipeline', 'CodeWrite'];
    default:
      return;
  }
}
